<template>
    <div id="home">
        <top></top>
        <div class="mian" :style="{ height: mianH + 'px' }">
            <left></left>
            <div id="novel_main">
                <ScriptCreate></ScriptCreate>
            </div>

        </div>
    </div>
</template>

<script>
import top from '@/components/top.vue' //顶部
import left from '@/components/left.vue' //左侧
import ScriptCreate from '@/components/script/script_create.vue' //右侧创建

export default {
    components: {
        top, left, ScriptCreate
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        }
    }
}
</script>

<style>
#novel {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
}

.mian {
    display: flex;
    min-width: 1500px;
}
</style>